import { useState } from 'react';

export default function Breadcrumb({ items }: { items: { label: string; path?: string }[] }) {
  return (
    <nav aria-label="面包屑导航" className="site-container px-4 md:px-6 py-4">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>}
            {item.path ? (
              <a href={item.path} className="hover:text-primary-600 transition-colors cursor-pointer">
                {item.label}
              </a>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}